<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 ">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-100"
            v-for="(item, index) in panel_graphs"
            :key="index"
          >
            <chart-card
              ref="chartcard"
              header-animation="false"
              :chart-data="{
                labels: item.data.labels.map((label) => $t(label)),
                series: item.data.series.map((ser) => {
                  return Array.isArray(ser)
                    ? ser.map((el) => {
                        return {
                          ...el,
                          meta: tranformMeta(el.meta)
                        }
                      })
                    : {
                        ...ser,
                        meta: tranformMeta(ser.meta)
                      }
                })
              }"
              :chart-options="{
                ...item.options,
                height: '230px',
                plugins: [
                  $Chartist.plugins.tooltip({
                    tooltipOffset: {x: -10, y: -22},
                    anchorToPoint: false,
                    tooltipFnc: function(meta, value) {
                      const oMeta = JSON.parse(meta)
                      return `${$t(oMeta.data.title)}: ${value}`
                    }
                  })
                ]
              }"
              :chart-type="
                item.type.charAt(0).toUpperCase() + item.type.slice(1)
              "
              header-icon
              chart-inside-content
              :no-footer="item.type !== 'pie' && !item.hasFooter"
              :background-color="item.colour"
            >
              <template slot="chartInsideHeader">
                <div class="card-icon">
                  <md-icon>{{ item.icon }}</md-icon>
                </div>
                <h4 class="title">
                  {{ $t(item.title) }}
                </h4>
              </template>
              <template slot="footer">
                <div class="md-layout">
                  <div class="md-layout-item md-size-100">
                    <h6 class="category">{{ $t('graph.legend') }}</h6>
                  </div>
                  <template v-if="item.type === 'pie'">
                    <div
                      class="md-layout-item legend-label md-medium-size-30 md-small-size-100"
                      v-for="(elem, index) in item.data.labels"
                      :key="elem"
                    >
                      <i
                        class="fa fa-circle"
                        :class="{
                          [chartLegendColor[index]]: !getMetaColor(
                            item.data.series[index].meta
                          )
                        }"
                        :style="{
                          color: getMetaColor(item.data.series[index].meta)
                        }"
                      ></i>
                      {{ $t(elem) }}
                    </div>
                  </template>
                </div>
              </template>
            </chart-card>
          </div>
        </div>
      </div>
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 ">
        <div class="md-layout">
          <div
            v-for="(item, index) in panel_cards"
            :key="index"
            class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50"
          >
            <stats-card :header-color="item.Colour">
              <template slot="header">
                <div class="card-icon">
                  <md-icon>{{ item.Icon }}</md-icon>
                  <!--i :class="item.Icon"></i-->
                </div>
                <p class="category">{{ $t(item.Text) }}</p>
                <h3 class="title">
                  <animated-number :value="item.Value"></animated-number>
                </h3>
              </template>

              <template slot="footer">
                <div class="stats">
                  {{ $t(item['Sub-text']) }}
                </div>
              </template>
            </stats-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tooltip2 from './ChartistPlugin/chartist-plugin-tooltip2'
import tooltip from './ChartistPlugin/chartist-plugin-tooltip'

import {StatsCard, AnimatedNumber, ChartCard} from '@/components'
import {mapState} from 'vuex'

// $Chartist.plugins.tooltip2({
// your options here (see below)
//template: popupFormat(),
//id: `${item.title}-${index}`
//}) --

export default {
  components: {
    StatsCard,
    AnimatedNumber,
    ChartCard
  },
  data() {
    return {
      items: [],
      chartLegendColor: [
        'text-info',
        'text-danger',
        'text-warning',
        'text-primary',
        'text-success'
      ]
    }
  },
  watch: {
    locale_active() {
      this.$nextTick(() => {
        this.$refs.chartcard.forEach((graph, index) => {
          graph['chart-data'] = {
            labels: this.panel_graphs[index].data.labels.map((label) =>
              this.$t(label)
            )
          }
          graph.updateChart()
        })
      })
    }
  },
  methods: {
    tranformMeta(meta) {
      return typeof meta === 'object'
        ? {...meta, title: this.$t(meta.title)}
        : {title: this.$t(meta)}
    },
    getMetaColor(meta) {
      return typeof meta === 'object' && meta.color ? meta.color : false
    },
    popupFormat() {
      return '<p>{{title}}: {{value}}</p>'
    }
  },

  computed: {
    chart_data() {
      return []
    },
    ...mapState({
      panel_data: (state) => state.Kpi.panel_data,
      locale_active: (state) => state.i18nStore.active
    }),
    panel_cards() {
      return this.panel_data['dashboard-cards']
    },
    panel_graphs() {
      return this.panel_data['dashboard-graphs']
    }
  }
}
</script>
<style lang="scss">
@import '@/assets/scss/md/_colors.scss';
//@import './ChartistPlugin/chartist-plugin-tooltip2.css';
@import './ChartistPlugin/chartist-plugin-tooltip.css';

p.category {
  min-height: 4rem;
}
.legend-label {
  i:first-child {
    padding-left: 0px;
  }
  i {
    padding-left: 10px;
  }
}
</style>
